export default "__VITE_PUBLIC_ASSET__7ae3adc4__"